import React, { useCallback } from "react";
import ProfileAdministrationAddressView from "./profile-administration-address-view";
import { ChangePasswordAction } from "../../actions";

const ProfileAdministrationConfiguration = (props) => {
    let {
        t,
        viewSelected,
        showPrincipalView,
        userPathImage,
        address,
        toggleLoadingRequesting,
        toggleCompletedRequesting,
        toggleErrorRequesting
    } = props

    const renderComponentProfile = useCallback(() => {
        switch (viewSelected) {
            case t("profileAdministrationPrincipalView.btn.update.address"):
                return(
                    <ProfileAdministrationAddressView
                        {...props}
                    />
                )
            case t("profileAdministrationPrincipalView.btn.change.password"):
                return(
                    <ChangePasswordAction 
                        isProfileView
                        toggleLoadingRequestingProfile={toggleLoadingRequesting}
                        toggleCompletedRequestingProfile={toggleCompletedRequesting}
                        toggleErrorRequestingProfile={toggleErrorRequesting}
                        {...props}
                    />
                )
        
            default:
        }
    }, [
        viewSelected,
        showPrincipalView,
        userPathImage,
        address
    ])

    return <>{renderComponentProfile()}</>;
}

export { ProfileAdministrationConfiguration as default }